<template>
    <div>
        <card-header title="Payment Plans" icon="fa-money-check-alt" />

        <card-body>
            <card-list>
                <template v-if="currentUser.role === 'dev' || currentUser.role === 'admin'">
                    <navigation-list-item
                        title="Pending Payment Plans"
                        icon="fa-timer"
                        :badge="(paymentPlanCounts.pendingPlans) ? paymentPlanCounts.pendingPlans : null"
                        :active="(child && child.definition.component === 'pending-plans')"
                        @click="$openCard('pending-plans', {}, card)"
                    />

                    <navigation-list-item
                        title="Pending Payment Submissions"
                        icon="fa-credit-card"
                        :badge="(paymentPlanCounts.pendingSubmit) ? paymentPlanCounts.pendingSubmit : null"
                        :active="(child && child.definition.component === 'pending-submissions')"
                        @click="$openCard('pending-submissions', {}, card)"
                    />

                    <navigation-list-item
                        title="Pending Letters"
                        icon="fa-envelope"
                        :badge="(paymentPlanCounts.pendingLetters) ? paymentPlanCounts.pendingLetters : null"
                        :active="(child && child.definition.component === 'pending-letters')"
                        @click="$openCard('pending-letters', {}, card)"
                    />

                    <separator-list-item />

                    <navigation-list-item
                        title="Active Accounts"
                        icon="fa-play"
                        :badge="(paymentPlanCounts.activeAccounts) ? paymentPlanCounts.activeAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'active' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'active'}, card)"
                    />

                    <navigation-list-item
                        title="All Accounts"
                        icon="fa-money-check-alt"
                        :badge="(paymentPlanCounts.allAccounts) ? paymentPlanCounts.allAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'all' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'all'}, card)"
                    />

                    <navigation-list-item
                        title="Suspended Accounts"
                        icon="fa-snooze"
                        :badge="(paymentPlanCounts.suspendedAccounts) ? paymentPlanCounts.suspendedAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'suspended' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'suspended'}, card)"
                    />

                    <navigation-list-item
                        title="Accounts in Error State"
                        icon="fa-triangle-exclamation"
                        :badge="(paymentPlanCounts.erroredAccounts) ? paymentPlanCounts.erroredAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'errored' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'errored'}, card)"
                    />

                    <navigation-list-item
                        title="Accounts Missing Details"
                        icon="fa-circle-question"
                        :badge="(paymentPlanCounts.missingAccounts) ? paymentPlanCounts.missingAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'missing' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'missing'}, card)"
                    />

                    <separator-list-item />

                    <navigation-list-item
                        title="Accounts Past Due"
                        icon="fa-bell-ring"
                        :badge="(paymentPlanCounts.dueAccounts) ? paymentPlanCounts.dueAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'due' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'due'}, card)"
                    />
                    <navigation-list-item
                        title="Accounts in Default"
                        icon="fa-siren-on"
                        :badge="(paymentPlanCounts.defaultAccounts) ? paymentPlanCounts.defaultAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'default' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'default'}, card)"
                    />
                    <navigation-list-item
                        title="Accounts in Collections"
                        icon="fa-gavel"
                        :badge="(paymentPlanCounts.collectionsAccounts) ? paymentPlanCounts.collectionsAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'collections' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'collections'}, card)"
                    />

                    <separator-list-item />

                    <navigation-list-item
                        title="Recent Requests/Activity"
                        icon="fa-message-check"
                        :badge="(paymentPlanCounts.recentRequests) ? paymentPlanCounts.recentRequests : null"
                        :active="(child && child.definition.component === 'account-requests')"
                        @click="$openCard('account-requests', {}, card)"
                    />

                    <navigation-list-item
                        title="Recent Failed Transactions"
                        icon="fa-subtitles-slash"
                        :badge="(paymentPlanCounts.failedTransactions) ? paymentPlanCounts.failedTransactions : null"
                        :active="(child && child.definition.component === 'failed-transactions')"
                        @click="$openCard('failed-transactions', {}, card)"
                    />

                    <navigation-list-item
                        title="Pending Transactions"
                        icon="fa-calendar-clock"
                        :badge="(paymentPlanCounts.pendingTransactions) ? paymentPlanCounts.pendingTransactions : null"
                        :active="(child && child.definition.component === 'pending-transactions')"
                        @click="$openCard('pending-transactions', {}, card)"
                    />

                    <navigation-list-item
                        title="Pending Accounts"
                        icon="fa-business-time"
                        :badge="(paymentPlanCounts.pendingAccounts) ? paymentPlanCounts.pendingAccounts : null"
                        :active="(child && child.definition.component === 'plans-list' && 'pending' === child.props.type)"
                        @click="$openCard('plans-list', {type: 'pending'}, card)"
                    />
                </template>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import PlanTile from "@/components/tiles/PlanTile";

    import {client as http} from '../../http_client';
    import {mapActions, mapGetters} from "vuex";
    import NavigationListItem from "../../TIER/components/NavigationListItem.vue";
    import ConferenceTile from "../../components/tiles/ConferenceTile.vue";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem.vue";

    export default {
        components: {SeparatorListItem, ConferenceTile, NavigationListItem, PlanTile, CardHeader, CardBody, CardToolbar, CardList, SubheaderListItem},
        props: ['card', 'child'],
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['currentUser', 'paymentPlanCounts'])
        },
        methods: {
            ...mapActions(['getPaymentPlanCounts']),
            reload() {
                this.$emit('loading', true);
                this.getPaymentPlanCounts().then(data => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted: function () {

        }
    }
</script>
